<template>
  <label class="block text-xs font-medium text-grey-11 dark:text-dark-ink-muted mb-1">
    <slot></slot>
  </label>
</template>
<script setup>
import { defineProps } from 'vue'

defineProps({
  label: {
    type: String,
    default: '',
  },
})
</script>
